import React, { Fragment } from "react"
import { Grid, makeStyles } from "@material-ui/core"

/**
 * Graph Container
 * This is the container for displaying different graphs
 *
 */

const useStyles = makeStyles((theme) => ({
  legendContainer: {
    display: "flex",
  },
  bullet: {
    width: "0.8em",
    height: "0.8em",
    display: "inline-block",
  },
  activeLabel: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    top: "50%",
    margin: "0 5px 0 0",
    lineHeight: "1.1",
    transform: "translateY(-50%)",
    "& span": {
      display: "flex",
      height: "3em",
      justifyContent: "center",
      padding: "0 0 0 5px",
      whiteSpace: "nowrap",
      wordBreak: "keep-all",
      writingMode: "vertical-rl",
      textOrientation: "mixed",
      background: "white",
      transform: "rotate(-180deg)",
    },
    "&:after": {
      content: "''",
      display: "block",
      width: "100%",
      height: "1px",
      background: "black",
    },
  },
  border: {
    border: "5px solid #DB5205",
    padding: "0 10px",
  },
}))

interface IProps {
  data: { label: string; color: string }[]
  activeLegendText: string
  activeIndex: number
}

const CustomLegend: React.FC<IProps> = ({
  data,
  activeLegendText,
  activeIndex,
}) => {
  const classes = useStyles()

  return (
    <Grid
      container
      spacing={0}
      className={classes.legendContainer}
      justify="center"
    >
      {data.map((d, index) => (
        <Fragment key={index}>
          <Grid item xs={2}>
            {index === activeIndex && (
              <div className={classes.activeLabel}>
                <span>{activeLegendText}</span>
              </div>
            )}
          </Grid>
          <Grid
            item
            xs={8}
            className={index === activeIndex ? classes.border : ""}
          >
            <div
              className={classes.bullet}
              style={{ backgroundColor: d.color }}
            ></div>{" "}
            {d.label}
          </Grid>
          <Grid item xs={2}></Grid>
        </Fragment>
      ))}
    </Grid>
  )
}

export default CustomLegend
